import React from "react";
import LazyImage from "ui/LazyImage/LazyImage";
import styles from "./Payments.module.scss";

const Payments: React.FC = () => (
  <div className={styles.footerPayments}>
    <LazyImage
      className={styles.footerPaymentsImage}
      width={46}
      height={16}
      src="/img/footer/visa.svg"
      alt="Visa"
    />
    <LazyImage
      className={styles.footerPaymentsImage}
      width={35}
      height={27}
      src="/img/footer/master-card.svg"
      alt="Master card"
    />
    <LazyImage
      className={styles.footerPaymentsImage}
      width={44}
      height={16}
      src="/img/footer/mir.svg"
      alt="Mir"
    />
    <LazyImage
      className={styles.footerPaymentsImage}
      width={31}
      height={23}
      src="/img/footer/jcb.svg"
      alt="JCB"
    />
  </div>
);

export default Payments;
